import ReactECharts from 'echarts-for-react';
import './DonutChart.css';

interface PieChartData {
  label: string;
  value: number;
  color?: string;
}

interface DonutChartProps {
  data: PieChartData[];
}

const COLORS = [
  '#67AEFF',
  '#FF89A0',
  '#FFF3B5',
  '#0088FE',
  '#00C49F',
  '#FFBB28',
];

export default function DonutChart({ data }: DonutChartProps) {
  const chartData = data.map((item, index) => {
    return {
      name: item.label,
      value: item.value,
      itemStyle: {
        color: item.color || COLORS[index % COLORS.length]
      }
    };
  });

  if (!data || data.length === 0) {
    return (
      <div
        style={{
          height: 340,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#A7A3E2',
        }}
      >
        Keine Daten verfügbar
      </div>
    );
  }

  const option = {
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(20, 20, 30, 0.9)',
      borderColor: 'rgba(147, 142, 211, 0.3)',
      textStyle: { color: '#F3F1FF', fontFamily: 'Inter, sans-serif' },
    },
    legend: {
      orient: 'horizontal',
      bottom: '0%',
      left: 'center',
      textStyle: { color: '#F3F1FF', fontFamily: 'Inter, sans-serif', fontSize: 12 },
      icon: 'circle',
      itemGap: 24
    },
    series: [
      {
        name: 'Distribution',
        type: 'pie',
        radius: ['56%', '70%'],
        center: ['50%', '42%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center'
        },
        labelLine: {
          show: false
        },
        data: chartData
      }
    ]
  };

  return (
    <ReactECharts 
      option={option}
      style={{ height: '340px', width: '100%' }}
      opts={{ renderer: 'canvas' }}
    />
  );
}
